import ProppingItem from '../ProppingItem';
import bracketsMixin from './bracketsMixin';

export default class BoaxelProppingItem extends bracketsMixin(ProppingItem) {}
